module.exports = __webpack_public_path__ + "static/media/kids_55.f2e6b971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_55.jpg
// module id = 5911
// module chunks = 0